import React, { useState, useEffect } from 'react'
import api from '../api/api'
import swal from 'sweetalert'
import { useTranslation } from "react-i18next";
import { Modal, Button, ButtonGroup, Row, Col, Form } from "react-bootstrap"

import "leaflet/dist/leaflet.css";
import { EditControl } from "react-leaflet-draw";
import LeafletMap from './map';
import EditableMap from './EditableMap';
import "../styles/management-pages.css";


const FieldList = ({ FieldsList, Fields, Uid }) => {
    const { t, i18n } = useTranslation();

    const [toggle, setToggle] = useState(false);
    const [showDeletedModal, setShowDeletedModal] = useState(false);
    
    const [data, setData] = useState([]);
    const [deletedFields, setDeletedFields] = useState([]);

    const [msgServer, setMsg] = useState("")
    const [classMsg, setCmsg] = useState("")
    const [displayMsg, setDispMsg] = useState("hide")
    const [iconMsg, setIconMsg] = useState("info")
    const [sensorsCoords, setSensorsCoords] = useState([])
    const [localFields, setLocalFields] = useState(FieldsList || []);

    const [SingleField, setSingleField] = useState([]);
    const [name, setName] = useState('');
    const [farm, setFarmUid] = useState('');
    const [description, setDesc] = useState('')
    const [mapConfig, setMapConfig] = useState({
        zoom: "",
        center: [],
        fromAction: false,
        draw: {
            polygon: true,
            circle: false,
            rectangle: false,
            polyline: false,
            marker: false,
            circlemarker: false,
        }
    })
    const [layer, setLayer] = useState('')

    const [coords, setCoords] = useState({
        Latitude: "",
        Longitude: "",
        zoom: "",
        center: [],
        fromAction: false
    })

    useEffect(() => {
        const getFarms = async () => {
            let url = '/farm/farms';
            if (Uid) {
                url = `/admin/user/${Uid}/farms`;
            }
            await api.get(url)
                .then(response => {
                    let farms = response.data.farms
                    setData(farms);
                }).catch(err => {
                    console.error(err)
                })

        }

        getFarms();
        fetchDeletedFields();
    }, []);

    useEffect(() => {
        setLocalFields(FieldsList);
    }, [FieldsList]);

    // Fetch deleted fields
    const fetchDeletedFields = async () => {
        try {
            let url = '/field/deleted-fields';
            if (Uid) {
                url = `/admin/user/${Uid}/deleted-fields`;
            }
            const response = await api.get(url);
            if (response.data && response.data.deletedFields) {
                setDeletedFields(response.data.deletedFields);
            }
        } catch (error) {
            console.error('Error fetching deleted fields:', error);
        }
    };

    // Restore a deleted field
    const handleRestore = async (fieldUid) => {
        try {
            const response = await api.post('/field/restore-field', { field_uid: fieldUid });
            if (response.data.type === "success") {
                swal({
                    title: t('field_restored') || 'Field Restored Successfully',
                    icon: "success",
                });
                
                // Refresh the lists
                fetchDeletedFields();
                Fields(); // Refresh main fields list
                setShowDeletedModal(false);
            } else {
                swal({
                    title: t('restore_failed') || 'Failed to restore field',
                    icon: "error",
                });
            }
        } catch (error) {
            swal({
                title: t('restore_error') || 'Error restoring field',
                icon: "error",
                text: error.message
            });
        }
    };

    // Permanently delete a field
    // const handlePermanentDelete = async (fieldUid) => {
    //     swal({
    //         title: t('permanent_delete_warning') || 'Permanent Delete',
    //         text: t('permanent_delete_confirm') || 'This action cannot be undone. Are you sure?',
    //         icon: "warning",
    //         buttons: true,
    //         dangerMode: true,
    //     }).then(async (willDelete) => {
    //         if (willDelete) {
    //             try {
    //                 const response = await api.delete('/field/permanent-delete', { 
    //                     data: { field_uid: fieldUid }
    //                 });
    //                 if (response.data.type === "success") {
    //                     swal({
    //                         title: t('permanent_delete_success') || 'Field permanently deleted',
    //                         icon: "success",
    //                     });
    //                     fetchDeletedFields();
    //                 }
    //             } catch (error) {
    //                 swal({
    //                     title: t('delete_error') || 'Error deleting field',
    //                     icon: "error",
    //                 });
    //             }
    //         }
    //     });
    // };

    const getSingleField = async (fieldUid) => {

        let dataField = {
            field_uid: fieldUid,
        }

        await api.post('/field', dataField)
            .then(res => {
                let fieldData = res.data.field
                setSingleField(fieldData)
                setName(fieldData.name)
                setDesc(fieldData.description)
                setLayer(fieldData.coordinates || '')
                setCoords({
                    Latitude: fieldData.Latitude ?? "",
                    Longitude: fieldData.Longitude ?? "",
                    zoom: "",
                    center: [],
                    fromAction: false
                })
                data.map((farmData) => {
                    if (fieldData.farm_id == farmData.id) {
                        setFarmUid(farmData.uid)
                    }
                    let sensorsCoord = []
                    let fields = farmData.fields;
                    fields.map(field => {
                        let sensors = field.sensors;
                        if (sensors) {
                            sensors.map(sensor => {
                                sensorsCoord.push({
                                    code: sensor.code,
                                    Latitude: sensor.Latitude,
                                    Longitude: sensor.Longitude
                                })
                            })
                        }
                    })
                    setSensorsCoords(sensorsCoord)
                })
            }).catch(error => {
                swal({
                    title: t("Error"),
                    icon: "error",

                });

            })
        setToggle(!toggle)
    }

    const handleEdit = (fieldUid) => {
        const hasBoundary = typeof layer === "string" && layer.trim() !== "";
        const hasValidLocation =
            coords.Latitude !== "" &&
            coords.Longitude !== "" &&
            Number.isFinite(Number(coords.Latitude)) &&
            Number.isFinite(Number(coords.Longitude));

        if (!hasBoundary || !hasValidLocation) {
            swal(t("Error"), t("please_draw_field"), "error");
            return;
        }

        let data = {
            name: name,
            farm_uid: farm,
            field_uid: fieldUid,
            description: description,
            coordinates: layer,
            Latitude: coords.Latitude,
            Longitude: coords.Longitude
        }

        api.post('/field/edit-field', data)
            .then(response => {
                if (response.data.type == "success") {
                    swal(`${t('field_updated')}`, {
                        icon: "success",
                    });
                    setToggle(false)
                    Fields();
                }
                if (response.data.type && response.data.type == "danger") {
                    swal({
                        icon: 'error',
                        title: t('Oops...'),
                        text: t('Error')
                    })
                    return false;
                }
            }).catch(error => {
                swal({
                    icon: 'error',
                    title: t('Oops...'),
                    text: t('Error')
                })
            })
    }

    const handleDelete = async fieldUid => {
        let data = {
            field_uid: fieldUid,
        }
        return await api.delete('/field/delete-field', { data: data })
            .then(response => {
                if (response.data.type && response.data.type == "danger") {
                    swal({
                        title: `${t('cannot_delete')}`,
                        icon: "warning",
                    });
                    return false;
                }
                if (response.data.type == "success") {
                    setLocalFields(prev => prev.filter(field => field.Uid !== fieldUid));
                    fetchDeletedFields(); // Refresh deleted fields list
                    setMsg(`${t('delete_success_field')}`)
                    setCmsg("success")
                    setDispMsg("show")
                    setIconMsg("check")
                    hideMsg()
                    return true;
                }
                return false;
            }).catch(error => {
                swal({
                    title: `${t('cannot_delete')}`,
                    icon: "error",
                    text: t('Error')

                });
                return false;
            })
    }

    const hideMsg = () => {
        setTimeout(() => {
            setDispMsg("hide")
        }, 3000);
    }

    const confirmDelete = fieldUid => {
        swal({
            title: `${t('are_you_sure')}`,
            text: `${t('confirm_delete')}`,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then(async (Delete) => {
                if (Delete) {
                    await handleDelete(fieldUid)
                }
            }).catch(error => {
                swal({
                    title: `${t('cannot_delete')}`,
                    icon: "error",
                    text: t('Error')

                });
            })
    }

    return (
        <>
            {displayMsg === "show" && (
                <div className={`mb-3 alert alert-${classMsg} fade show`}>
                    <i className={`fa fa-${iconMsg} mx-2`}></i> {t(msgServer)}
                </div>
            )}
            
            {/* Button to show deleted fields */}
            <div className="mb-3">
                <Button 
                    variant="secondary" 
                    onClick={() => {
                        setShowDeletedModal(true);
                        fetchDeletedFields();
                    }}
                >
                    <i className="fa fa-trash-restore mx-2"></i>
                    {t('deleted_fields') || 'Deleted Fields'}
                    {deletedFields.length > 0 && (
                        <span className="badge bg-danger ms-2">{deletedFields.length}</span>
                    )}
                </Button>
            </div>

            <div style={{ overflowX: 'auto' }}>
                <table className="table mb-4 text-center table-bordered table-responsive-lg" >
                    <thead className="bg-light">
                        <tr>
                            <th scope="col" className="border-0">{t('name')}</th>
                            <th scope="col" className="border-0">{t('status')}</th>
                            <th scope="col" className="border-0">{t('name_farm')}</th>
                            <th scope="col" className="border-0"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            localFields?.map((item, indx) => {
                                let nameFarm = "";
                                data.map((farmData) => {
                                    if (farmData.id == item.farm_id) {
                                        nameFarm = farmData.name
                                    }
                                })
                                return (
                                    <tr key={item.Uid}>
                                        <td>{item.title}</td>
                                        <td>{item.status}</td>
                                        <td>{nameFarm}</td>
                                        <td>
                                            <ButtonGroup size="sm" className="mr-2 gap-2">
                                            <Button onClick={() => getSingleField(item.Uid)} variant="info"><i className="fas fa-pen" aria-hidden="true" /></Button>
                                                <Button onClick={() => confirmDelete(item.Uid)} variant="danger"><i className="fas fa-trash" aria-hidden="true" /></Button>
                                            </ButtonGroup>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>

            {/* Edit Field Modal */}
            <Modal size="xl" scrollable dialogClassName="entity-edit-modal entity-edit-modal-map" show={toggle} onHide={() => setToggle(false)} aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header closeButton className="entity-edit-header">
                    <h6 className="m-0">{t('edit_field')}</h6>{" "}
                    <div className="entity-edit-actions">
                        <Button
                            className="mb-2 mr-1 btn btn-success"
                            onClick={() => handleEdit(SingleField.uid)}
                        >
                            {t('save')}
                            <i className="fas fa-check mx-2" aria-hidden="true" />
                        </Button>
                        <Button
                            className="mb-2 mr-1 btn btn-danger"
                            onClick={() => setToggle(false)}
                        >
                            {t('cancel')}
                            <i className="fas fa-times mx-2" aria-hidden="true" />
                        </Button>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <Form className="entity-edit-form">
                        <Row form className='gap-2 justify-content-between'>
                            <Col md="6" className="form-group">
                                <p style={{ margin: "0px" }}>{t('name_farm')}</p>
                                <Form.Select
                                    value={farm}
                                    onChange={(e) => setFarmUid(e.target.value)}
                                    required
                                >
                                    {
                                        data.map((farmData) => {
                                            return (<option key={farmData.uid} value={farmData.uid}>{farmData.name}</option>)
                                        })
                                    }
                                </Form.Select>
                            </Col>
                            <Col md="5" className="form-group">
                                <p style={{ margin: "0px" }}>{t('name_field')}</p>
                                <Form.Control
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    style={{ height: "40px" }}
                                />
                                <div className="invalid-feedback">{t('no_empty')}</div>
                            </Col>
                            <Col lg='12' md="12" sm='12' className="form-group">
                                <EditableMap
                                    sensorsCoords={sensorsCoords}
                                    setLayer={setLayer}
                                    setCoords={setCoords}
                                    initialLayer={SingleField.coordinates}
                                    initialCoords={{
                                        Latitude: SingleField.Latitude,
                                        Longitude: SingleField.Longitude
                                    }}
                                />
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
            </Modal>

            {/* Deleted Fields Modal */}
            <Modal size="lg" show={showDeletedModal} onHide={() => setShowDeletedModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{t('deleted_fields') || 'Deleted Fields'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {deletedFields.length === 0 ? (
                        <div className="text-center py-4">
                            <i className="fa fa-inbox fa-3x text-muted mb-3"></i>
                            <p className="text-muted">{t('no_deleted_fields') || 'No deleted fields found'}</p>
                        </div>
                    ) : (
                        <div style={{ overflowX: 'auto' }}>
                            <table className="table text-center table-bordered">
                                <thead className="bg-light">
                                    <tr>
                                        <th>{t('name')}</th>
                                        <th>{t('name_farm')}</th>
                                        <th>{t('deleted_at') || 'Deleted At'}</th>
                                        <th>{t('actions') || 'Actions'}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {deletedFields.map((field) => {
                                        let farmName = "";
                                        data.forEach((farmData) => {
                                            if (farmData.id === field.farm_id) {
                                                farmName = farmData.name;
                                            }
                                        });
                                        
                                        return (
                                            <tr key={field.Uid || field.uid}>
                                                <td>{field.title || field.name}</td>
                                                <td>{farmName}</td>
                                                <td>
                                                    {field.deleted_at ? 
                                                        new Date(field.deleted_at).toLocaleDateString() : 
                                                        'N/A'
                                                    }
                                                </td>
                                                <td>
                                                    <ButtonGroup size="sm">
                                                        <Button 
                                                            variant="success" 
                                                            onClick={() => handleRestore(field.Uid || field.uid)}
                                                            title={t('restore') || 'Restore'}
                                                        >
                                                            <i className="fa fa-undo"></i> {t('restore') || 'Restore'}
                                                        </Button>
                                                        {/* <Button 
                                                            variant="danger" 
                                                            onClick={() => handlePermanentDelete(field.Uid || field.uid)}
                                                            title={t('permanent_delete') || 'Delete Permanently'}
                                                        >
                                                            <i className="fa fa-trash"></i>
                                                        </Button> */}
                                                    </ButtonGroup>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeletedModal(false)}>
                        {t('close') || 'Close'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default FieldList
